import { render, staticRenderFns } from "./init.vue?vue&type=template&id=078ab668&scoped=true&"
import script from "./init.vue?vue&type=script&lang=js&"
export * from "./init.vue?vue&type=script&lang=js&"
import style0 from "./init.vue?vue&type=style&index=0&id=078ab668&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "078ab668",
  null
  
)

export default component.exports